import type { Provider } from '../PreCheckedProviders.types'

/**
 * "No swipe" logic, checks if there are any providers who are "no swipe" BE
 * labels "no swipe" providers as "directBill"
 *
 * @param providers Prechecked providers
 * @returns True if there is at least one "no swipe" provider, false if no
 *   provider is "no swipe"
 */
export const checkForAnyNoSwipe = (providers: Provider[]): boolean => {
  return providers.some(provider => provider.directBill)
}
